var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "product-item",
      class: {
        "product-item--refunded": _vm.isRefundable,
        "product-item--unavailable": _vm.isUnavailableAtPharmacyPoint,
        "product-item--rx": _vm.isRx,
        "product-item--product-of-the-week": _vm.dataProductOfTheWeek,
        "-list": _vm.isInListView
      }
    },
    [
      _vm.dataProductOfTheWeek
        ? _c(
            "div",
            { staticClass: "product-item__product-of-the-week-label" },
            [_vm._v("\n        Produkt tygodnia\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.labels && !_vm.isRx && !_vm.dataProductOfTheWeek
        ? _c(
            "ul",
            { staticClass: "product-item__labels" },
            _vm._l(_vm.labelsCropped, function(label, attr) {
              return _c("li", { key: attr }, [
                _c("a", { attrs: { href: label.url } }, [
                  _c(
                    "span",
                    {
                      staticClass: "product-label",
                      class: "product-label--" + attr
                    },
                    [
                      _c("span", { staticClass: "product-label__text" }, [
                        _vm._v(_vm._s(label.name))
                      ])
                    ]
                  )
                ])
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c("button", {
        ref: "wishlistButton",
        class: [
          _vm.wishList ? "wishlist-added" : "",
          _vm.isInListView ? "-list" : "",
          "btn-link product-shop__link product-options__btn product-shop__link wishlist link-wishlist wishlist-container"
        ],
        attrs: {
          id: "ph_catalogwishlist_" + _vm.id,
          rel: "whishlist",
          "data-product-id": _vm.id,
          "data-wishlist-add": "/wishlist/index/ajaxAdd",
          "data-wishlist-remove": "/wishlist/index/ajaxRemove",
          "data-vue-init": "add-to-wishlist",
          title: "Dodaj do ulubionych",
          "aria-label": "Dodaj do ulubionych produkt " + _vm.name
        },
        on: { click: _vm.addToWishlist }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "product-item__img",
          class: { "-list": _vm.isInListView }
        },
        [
          _c(
            "a",
            {
              staticClass: "product-image",
              attrs: { href: _vm.url, title: _vm.name }
            },
            [
              _vm.isRx
                ? [
                    _c(
                      "div",
                      { staticClass: "product-item__rx product-rx__info" },
                      [
                        _c("img", {
                          attrs: {
                            src: _vm.rxImage,
                            alt: _vm.name,
                            loading: "lazy",
                            height: "190",
                            width: "190"
                          }
                        }),
                        _vm._v(" "),
                        _c("strong", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.i18n(
                                  _vm.isRefundable ? "refunded" : "not refunded"
                                )
                              ) +
                              "\n                    "
                          )
                        ])
                      ]
                    )
                  ]
                : [
                    _c("img", {
                      class: { "product-lazy": _vm.isLazyImg },
                      style: !_vm.isInCatalogView && _vm.imgLabelsMarginTop,
                      attrs: {
                        width: "190",
                        height: "190",
                        alt: _vm.name,
                        src: !_vm.isLazyImg
                          ? _vm.image
                          : "data:image/gif;base64,R0lGODlhAQABAAAAACw=",
                        "data-src": _vm.isLazyImg ? _vm.image : null
                      },
                      on: { error: _vm.replaceWithPlaceholder }
                    })
                  ],
              _vm._v(" "),
              _vm.isUnavailableAtPharmacyPoint
                ? [
                    _c("div", { staticClass: "product-item__unavailable" }, [
                      _c("div", [
                        _c(
                          "span",
                          { staticClass: "icon-wrapper" },
                          [
                            _c("BlockedIcon", {
                              attrs: { width: "18", height: "18" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.i18n("Product is unavailable")))
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.upsellLink
                        ? _c(
                            "span",
                            {
                              staticClass: "product-item__unavailable-link",
                              attrs: {
                                "data-vue-init": "upsell-modal",
                                "data-url": _vm.upsellLink,
                                "data-product": _vm.name
                              }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.i18n("See similar products")) +
                                  "\n                    "
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  ]
                : _vm._e()
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "mobile-column-for-row-view" }, [
        _c("div", { staticClass: "mobile-column" }, [
          _c(
            "div",
            {
              staticClass: "product-item__desc",
              class: { "-list": _vm.isInListView }
            },
            [
              _c("p", { staticClass: "product-item__name" }, [
                _c("a", { attrs: { href: _vm.url, title: _vm.name } }, [
                  _vm._v(_vm._s(_vm.name))
                ])
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "product-item__tags",
                domProps: { textContent: _vm._s(_vm.keywords) }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "product-item__shop",
            class: {
              "product-item__shop--unavailable": !_vm.isAvailable,
              "-list": _vm.isInListView
            }
          },
          [
            _c(
              "ProductItemForm",
              _vm._b(
                {
                  attrs: {
                    "unavailable-at-pharmacy-point":
                      _vm.isUnavailableAtPharmacyPoint,
                    "ga-list-value": _vm.gaListValue
                  }
                },
                "ProductItemForm",
                _vm.$props,
                false
              )
            ),
            _vm._v(" "),
            !_vm.isRefundable && _vm.isAvailable
              ? _c("div", {
                  staticClass: "tooltip-max-price-info",
                  domProps: { innerHTML: _vm._s(_vm.maxPriceInfoTooltip) }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }